import ZCaption from './ZCaption.vue'

export default ZCaption
